const TaskPreferredLocation = {
    EXISTING: 'EXISTING',
    LAST: 'LAST'
};

export {TaskPreferredLocation};
